import { render } from "./StudySpace.vue?vue&type=template&id=4ae47ade&scoped=true"
import script from "./StudySpace.vue?vue&type=script&lang=js"
export * from "./StudySpace.vue?vue&type=script&lang=js"

import "./StudySpace.vue?vue&type=style&index=0&id=4ae47ade&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae47ade"]])

export default __exports__